import { ResponseGenerator } from 'common/type';
import { trimQueryData } from 'helpers/params';
import { call, put, takeLatest } from 'redux-saga/effects';

import {
  getMenuAuthorityAPI,
  getMenuAuthorityDetailAPI,
  getScreenListAPI,
  numberingAPI,
  addMenuAuthorityAPI,
  updateMenuAuthorityAPI,
  deleteMenuAuthorityAPI,
} from './api';
import {
  filterMenuAuthority,
  filterMenuAuthoritySuccess,
  filterMenuAuthorityFailure,
  getDetailMenuAuthority,
  getDetailMenuAuthoritySuccess,
  getDetailMenuAuthorityFailure,
  getScreen,
  getScreenSuccess,
  getScreenFailure,
  numbering,
  numberingSuccess,
  numberingFailure,
  registerMenuAuthority,
  registerMenuAuthoritySuccess,
  registerMenuAuthorityFailure,
  updateMenuAuthority,
  updateMenuAuthoritySuccess,
  updateMenuAuthorityFailure,
  deleteMenuAuthority,
  deleteMenuAuthoritySuccess,
  deleteMenuAuthorityFailure,
} from './slice';
import {
  SearchMenuAuthorityMasterRequest,
  DetailMenuAuthorityMasterRequest,
  UpdateMenuAuthorityMasterRequest,
} from 'api-types/src/types/menu-authority-master';

function* fetchMenuAuthorityMaster({ payload }: { payload: SearchMenuAuthorityMasterRequest }) {
  try {
    const response: ResponseGenerator = yield call(getMenuAuthorityAPI, trimQueryData(payload));
    yield put(filterMenuAuthoritySuccess(response.data));
  } catch (error) {
    yield put(filterMenuAuthorityFailure());
  }
}

function* fetchMenuAuthorityDetail({ payload }: { payload: DetailMenuAuthorityMasterRequest }) {
  try {
    const response: ResponseGenerator = yield call(getMenuAuthorityDetailAPI, payload);
    yield put(getDetailMenuAuthoritySuccess(response.data));
  } catch (error: any) {
    yield put(getDetailMenuAuthorityFailure({ message: error?.message }));
  }
}

function* fetchScreen() {
  try {
    const response: ResponseGenerator = yield call(getScreenListAPI);
    yield put(getScreenSuccess(response.data));
  } catch (error: any) {
    yield put(getScreenFailure({ message: error?.message }));
  }
}

function* fetchMenuAuthorityNumber() {
  try {
    const response: ResponseGenerator = yield call(numberingAPI);
    yield put(numberingSuccess(response.data));
  } catch (error: any) {
    yield put(numberingFailure({ message: error?.message }));
  }
}

function* registerMenuAuthoritySaga({ payload }: { payload: UpdateMenuAuthorityMasterRequest }) {
  try {
    const response: ResponseGenerator = yield call(addMenuAuthorityAPI, payload);
    yield put(registerMenuAuthoritySuccess(response));
  } catch (error: any) {
    yield put(registerMenuAuthorityFailure({ message: error?.message }));
  }
}

function* updateMenuAuthoritySaga({ payload }: { payload: UpdateMenuAuthorityMasterRequest }) {
  try {
    const response: ResponseGenerator = yield call(updateMenuAuthorityAPI, payload);
    yield put(updateMenuAuthoritySuccess(response));
  } catch (error: any) {
    yield put(updateMenuAuthorityFailure({ message: error?.message }));
  }
}

function* deleteMenuAuthoritySaga({ payload }: { payload: UpdateMenuAuthorityMasterRequest }) {
  try {
    const response: ResponseGenerator = yield call(deleteMenuAuthorityAPI, payload);
    yield put(deleteMenuAuthoritySuccess(response));
  } catch (error: any) {
    yield put(deleteMenuAuthorityFailure({ message: error?.message }));
  }
}

function* watchMenuAuthorityMaster() {
  yield takeLatest(filterMenuAuthority, fetchMenuAuthorityMaster);
  yield takeLatest(getDetailMenuAuthority, fetchMenuAuthorityDetail);
  yield takeLatest(getScreen, fetchScreen);
  yield takeLatest(numbering, fetchMenuAuthorityNumber);
  yield takeLatest(registerMenuAuthority, registerMenuAuthoritySaga);
  yield takeLatest(updateMenuAuthority, updateMenuAuthoritySaga);
  yield takeLatest(deleteMenuAuthority, deleteMenuAuthoritySaga);
}

export default watchMenuAuthorityMaster;
